import { useSingleType } from "./content";

/**
 * Textos da página /pbqh (single type `pbqh`). Ficam no código como padrão: o
 * que estiver preenchido no Strapi sobrescreve, e a tela de edição usa os
 * mesmos valores para pré-preencher os campos.
 */
export const PBQH_DEFAULTS = {
  eyebrow: "Qualidade",
  titulo: "Qualidade Bivver & PBQP-H",
  subtitulo:
    "Da concepção à entrega: um sistema de gestão auditado, certificado e presente em cada etapa da obra.",
  chips: [
    { texto: "100% conforme ABNT", icone: "escudo" },
    { texto: "Certificação PBQP-H / SiAC", icone: "medalha" },
    { texto: "Melhoria contínua (PDCA)", icone: "ciclo" },
    { texto: "Sustentabilidade no canteiro", icone: "folha" },
  ],
  intro: `A qualidade na Bivver Empreendimentos Imobiliários é compreendida de forma sistêmica e integrada. Ela permeia todo o ciclo de vida do empreendimento — desde a inteligência de mercado, concepção arquitetônica e rigoroso planejamento financeiro e executivo, até a gestão padronizada do canteiro de obras, o acompanhamento criterioso de todas as etapas construtivas e o suporte pós-entrega dedicado.

Construir com excelência significa alinhar engenharia de alta performance, processos previsíveis, governança técnica e um relacionamento transparente e duradouro com o cliente.`,
  tituloPolitica: "Política da Qualidade Bivver",
  leadPolitica:
    "A Política da Qualidade da Bivver está fundamentada em quatro pilares estratégicos:",
  pilares: [
    {
      icone: "alvo",
      titulo: "Foco no Cliente e na Experiência do Morador",
      texto:
        "Compreender e superar as expectativas dos clientes, entregando espaços funcionais, seguros e com elevado valor agregado.",
    },
    {
      icone: "escudo",
      titulo: "Conformidade Normativa e Rigor Técnico",
      texto:
        "Garantir o alinhamento de 100% dos projetos e obras às normas técnicas vigentes (ABNT) e aos parâmetros de segurança e desempenho.",
    },
    {
      icone: "ciclo",
      titulo: "Melhoria Contínua do Sistema de Gestão",
      texto:
        "Otimizar constantemente os processos construtivos e operacionais, mitigando riscos e eliminando desperdícios.",
    },
    {
      icone: "guindaste",
      titulo: "Valorização da Cadeia de Suprimentos",
      texto:
        "Manter parcerias sólidas com projetistas, fornecedores e empreiteiros qualificados para assegurar padrão técnico em todas as entregas.",
    },
  ],
  tituloCertificacao: "Qualidade e Conformidade: PBQP-H / SiAC",
  introCertificacao:
    "A Bivver integra o Programa Brasileiro da Qualidade e Produtividade do Hábitat (PBQP-H), por meio do Sistema de Avaliação da Conformidade de Empresas de Serviços e Obras da Construção Civil (SiAC). Essa adesão voluntária e certificada comprova a existência de um Sistema de Gestão da Qualidade (SGQ) robusto, auditado periodicamente por organismos independentes.",
  leadCertificacao:
    "O que a certificação PBQP-H representa para o cliente e para a obra:",
  beneficios: [
    {
      icone: "check",
      titulo: "Garantia de Desempenho (NBR 15575)",
      texto:
        "Cumprimento rigoroso dos critérios de segurança estrutural, estanqueidade, conforto acústico, térmico e durabilidade das edificações.",
    },
    {
      icone: "planta",
      titulo: "Qualificação de Fornecedores e Insumos",
      texto:
        "Utilização exclusiva de materiais certificados e testados, combatendo a não conformidade e garantindo a longevidade da obra.",
    },
    {
      icone: "frasco",
      titulo: "Rastreabilidade e Ensaios Tecnológicos",
      texto:
        "Controle sistemático de recebimento de materiais (FVM) e execução de serviços (FVS), acompanhados por ensaios de laboratório (concreto, argamassa, vedações).",
    },
    {
      icone: "medalha",
      titulo: "Mitigação de Riscos e Padronização",
      texto:
        "Processos de canteiro mapeados e auditados, garantindo previsibilidade de prazos, custos e padrão de acabamento.",
    },
  ],
  citacao: "“Qualidade não acontece por acaso.\nÉ construída em cada etapa.”",
  compromissoLabel: "Nosso compromisso central",
  compromisso:
    "“Desenvolver, produzir e comercializar empreendimentos imobiliários com foco na qualidade, na satisfação dos clientes e na melhoria contínua de nossos processos.”",
  tituloFases: "Qualidade em Cada Etapa do Processo",
  leadFases:
    "Traduzimos nosso sistema de gestão em quatro fases operacionais bem definidas:",
  fases: [
    {
      titulo: "Planejamento",
      descricao:
        "Projetos e processos estruturados para orientar cada empreendimento.",
      itens:
        "Compatibilização multidisciplinar em tecnologia BIM\nAnálise preventiva de riscos construtivos e orçamentários\nPlanejamento executivo e cronograma físico-financeiro detalhado",
    },
    {
      titulo: "Execução",
      descricao:
        "Acompanhamento rigoroso das etapas construtivas e padrões estabelecidos.",
      itens:
        "Aplicação rigorosa dos Procedimentos de Execução de Serviços (PES)\nMão de obra qualificada e treinada em diretrizes normativas\nLogística enxuta e organização de canteiro",
    },
    {
      titulo: "Controle",
      descricao:
        "Monitoramento contínuo para identificar desvios e oportunidades.",
      itens:
        "Fichas de Verificação de Material (FVM) e de Serviço (FVS)\nAuditorias internas periódicas de conformidade técnica\nEnsaios tecnológicos laboratoriais contínuos",
    },
    {
      titulo: "Entrega",
      descricao:
        "Compromisso com a qualidade do imóvel e com a experiência do cliente.",
      itens:
        "Vistoria rigorosa pré-entrega e checklist de acabamentos\nEntrega do Manual do Usuário conforme ABNT NBR 14037\nAssistência técnica pós-obra ágil e estruturada",
    },
  ],
  tituloPdca: "Melhoria Contínua (Ciclo PDCA)",
  kickerPdca:
    "Melhorar faz parte do processo: avaliar, aprender, corrigir e aprimorar.",
  textoPdca:
    "A Bivver busca evoluir continuamente seus processos, produtos e serviços, transformando aprendizados operacionais em melhorias concretas para os próximos lançamentos. Através do método PDCA (Plan-Do-Check-Act), realizamos análises de desempenho ao final de cada fase construtiva, retroalimentando as equipes de projeto, orçamento e engenharia. Dessa forma, eliminamos reincidências de falhas, reduzimos custos de retrabalho e elevamos o padrão de entrega.",
  tituloSustentabilidade: "Sustentabilidade Prática em Canteiro de Obras",
  kickerSustentabilidade: "Construir hoje pensando no amanhã.",
  introSustentabilidade:
    "Na Bivver, sustentabilidade não é apenas um conceito de marketing, mas sim um conjunto de práticas reais, objetivas e mensuráveis aplicadas no cotidiano dos nossos canteiros de obras. Nossas diretrizes ambientais englobam:",
  praticas: [
    {
      icone: "folha",
      titulo: "Gestão e Segregação de Resíduos",
      texto:
        "Coleta seletiva rigorosa de sobra de materiais em conformidade com a Resolução CONAMA 307/2002.",
    },
    {
      icone: "ciclo",
      titulo: "Redução de Desperdícios",
      texto:
        "Racionalização construtiva através do uso de alvenaria estrutural/modulada e sistemas pré-fabricados.",
    },
    {
      icone: "planta",
      titulo: "Uso Racional de Materiais",
      texto:
        "Compra planejada e estocagem adequada para evitar perdas por intempéries ou manuseio incorreto.",
    },
    {
      icone: "check",
      titulo: "Organização e Limpeza (Metodologia 5S)",
      texto:
        "Canteiros limpos e seguros, reduzindo acidentes, desperdícios e impacto na vizinhança.",
    },
    {
      icone: "onda",
      titulo: "Controle de Recursos Naturais",
      texto:
        "Monitoramento contínuo do consumo de água e energia elétrica nas fases de estrutura e acabamento.",
    },
    {
      icone: "folha",
      titulo: "Destinação Rastreável de Resíduos (RCC)",
      texto:
        "Encaminhamento exclusivo para áreas de reciclagem e aterros de resíduos da construção civil devidamente licenciados.",
    },
  ],
  citacaoFinal:
    "“Qualidade é o que permanece quando o projeto deixa de ser apenas uma ideia e se transforma em realidade.”",
  marcaFinal: "Bivver Empreendimentos Imobiliários",
  tagFinal: "Construímos lugares. Inspiramos um jeito de viver.",
  ctaTexto: "Falar com a Bivver ↗",
  selo: null,
  // Rodapé da página: o selo PBQP-H. Sem upload no Strapi, cai na imagem
  // empacotada em `src/images/pbqph-logo.png`.
  seloRodapeLegenda: "Empresa certificada PBQP-H / SiAC",
  seloRodape: null,
};

export function usePbqh() {
  return useSingleType("/pbqh", PBQH_DEFAULTS);
}
